import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';

import { Icon } from '@hz-design-system/web-ui';
import Classes from './BundleAdvantages.module.scss';

const advantages = [
  [
    'landingFreeBundle.advantages.advantage1',
    'landingFreeBundle.advantages.advantage2',
    'landingFreeBundle.advantages.advantage3',
  ],
  [
    'landingFreeBundle.advantages.advantage4',
    'landingFreeBundle.advantages.advantage5',
    'landingFreeBundle.advantages.advantage6',
  ],
];

const ListItem = ({ item }: { item: string }) => (
  <div className={Classes.listItem}>
    <div className={Classes.listItemIcon}>
      <Icon name="checkmark-circled" color="inverse" />
    </div>
    <div className={Classes.listItemText}>{item}</div>
  </div>
);

const BundleAdvantages = () => {
  const i18n = useI18nContext();
  return (
    <div className={Classes.root}>
      <h2 className={Classes.title}>{i18n.t('landingFreeBundle.advantages.title')}</h2>
      <div className={Classes.listWrapper}>
        {advantages.map((list, listColumnId) => (
          <div className={Classes.listColumn} key={listColumnId}>
            {list.map(
              (item, indexListItem) => i18n.tExists(item) && <ListItem item={i18n.t(item)} key={indexListItem} />,
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default BundleAdvantages;
